import React from 'react';
import {Step, Stepper} from '../../components/style-guide/stepper';
import SelectPayment from './components/select-payment-step/SelectPayment';
import Resume from './components/resume-step/Resume';
import {emptyFn, isNullOrUndefined} from '../../shared';
import GeneralData from './components/general-data/GeneralData';

export const NewReport = (props) => {
  const {
    state: {data, ui, finished, acceptTermAndConditions},
    userInfo,
    validateGeneralData,
    validateSelectedPayment,
    onBackPaymentSelected,
    updateBillInfo,
    deleteBillInfo,
    updatePaymentType,
    onCreateNewReport,
    generalDataRef,
    onCancel,
    updateGeneralData,
    acceptTermAndConditionsAction
  } = props;

  const paymentErrorMessages = ['Es requerido que seleccione un medio de pago.'];

  return (
      <div className="border-box h-100 p-4 p-sm-none">
        <Stepper
            finishButtonText="Pagar"
            onFinish={onCreateNewReport}
            onFinishDisabled={finished || !acceptTermAndConditions}
            onCancel={onCancel}>
          <Step
              title="Datos Generales"
              subTitle="Ingrese los datos solicitados"
              error={ui.generalDataStepErrors.length > 0}
              isDirty={ui.generalDataStepIsDirty}
              onValidateNext={validateGeneralData}>
            <GeneralData
                ref={generalDataRef}
                initialValues={data.generalData}
                userInfo={userInfo}
                updateGeneralData={updateGeneralData}
                {...props}/>
          </Step>
          <Step title="Forma de Pago"
                subTitle="Seleccione su forma de pago"
                error={isNullOrUndefined(data.paymentType)}
                errorMessage={paymentErrorMessages}
                isDirty={ui.paymentStepIsDirty}
                onValidateNext={validateSelectedPayment}
                onBack={onBackPaymentSelected}>
            <SelectPayment
                paymentType={data.paymentType}
                billInfo={data.billInfo}
                onEditBillInfo={updateBillInfo}
                onRemoveBillInfo={deleteBillInfo}
                onEditPaymentType={updatePaymentType}/>
          </Step>
          <Step title="Resumen" subTitle="Verifique los datos de su solicitud">
            <Resume
                data={data}
                acceptTermAndConditions={acceptTermAndConditions}
                acceptTermAndConditionsAction={acceptTermAndConditionsAction}/>
          </Step>
        </Stepper>
      </div>
  );
};

NewReport.defaultProps = {
  validateSelectedPayment: emptyFn(),
  onBackPaymentSelected: emptyFn(),
  updateBillInfo: emptyFn(),
  deleteBillInfo: emptyFn(),
  updatePaymentType: emptyFn(),
  onCancel: emptyFn(),
  acceptTermAndConditionsAction: emptyFn(),
  updateGeneralData: emptyFn(),
};

export default React.memo(NewReport);
